import {
  GET_UNMAPPED_POSITIONS,
  GET_UNMAPPED_POSITIONS_SUCCESS,
  GET_UNMAPPED_POSITIONS_FAIL,
  GET_UNMATCHED_CLASSIFICATIONS,
  GET_UNMATCHED_CLASSIFICATIONS_SUCCESS,
  GET_UNMATCHED_CLASSIFICATIONS_FAIL,
  GET_NO_CLASSIFICATION_POSITIONS,
  GET_NO_CLASSIFICATION_POSITIONS_SUCCESS,
  GET_NO_CLASSIFICATION_POSITIONS_FAIL,
  GET_CLASSIFICATIONS_LOOKUP,
  GET_CLASSIFICATIONS_LOOKUP_SUCCESS,
  GET_CLASSIFICATIONS_LOOKUP_FAIL,
  PROPOSE_POSITION_MAPPING,
  PROPOSE_POSITION_MAPPING_SUCCESS,
  PROPOSE_POSITION_MAPPING_FAIL,
  GET_PENDING_POSITION_MAPPINGS,
  GET_PENDING_POSITION_MAPPINGS_SUCCESS,
  GET_PENDING_POSITION_MAPPINGS_FAIL,
  DECIDE_POSITION_MAPPING,
  DECIDE_POSITION_MAPPING_SUCCESS,
  DECIDE_POSITION_MAPPING_FAIL,
  GET_MY_MAPPING_HISTORY,
  GET_MY_MAPPING_HISTORY_SUCCESS,
  GET_MY_MAPPING_HISTORY_FAIL,
} from "./actionTypes";

const initialState = {
  unmappedList: [],
  loadingUnmapped: false,
  unmatchedList: [],
  loadingUnmatched: false,
  noClassificationList: [],
  loadingNoClassification: false,
  classificationsLookupList: [],
  loadingClassificationsLookup: false,
  pendingList: [],
  loadingPending: false,
  myHistoryList: [],
  loadingMyHistory: false,
  postingResult: {},
  loading: false,
  error: {
    message: "",
  },
};

const PositionMappingReducer = (state = initialState, action) => {
  if (!action) return state;
  switch (action.type) {
    case GET_UNMAPPED_POSITIONS:
      state = { ...state, loadingUnmapped: true };
      break;
    case GET_UNMAPPED_POSITIONS_SUCCESS:
      state = { ...state, unmappedList: action.payload, loadingUnmapped: false };
      break;
    case GET_UNMAPPED_POSITIONS_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingUnmapped: false,
      };
      break;

    case GET_UNMATCHED_CLASSIFICATIONS:
      state = { ...state, loadingUnmatched: true };
      break;
    case GET_UNMATCHED_CLASSIFICATIONS_SUCCESS:
      state = { ...state, unmatchedList: action.payload, loadingUnmatched: false };
      break;
    case GET_UNMATCHED_CLASSIFICATIONS_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingUnmatched: false,
      };
      break;

    case GET_NO_CLASSIFICATION_POSITIONS:
      state = { ...state, loadingNoClassification: true };
      break;
    case GET_NO_CLASSIFICATION_POSITIONS_SUCCESS:
      state = { ...state, noClassificationList: action.payload, loadingNoClassification: false };
      break;
    case GET_NO_CLASSIFICATION_POSITIONS_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingNoClassification: false,
      };
      break;

    case GET_CLASSIFICATIONS_LOOKUP:
      state = { ...state, loadingClassificationsLookup: true };
      break;
    case GET_CLASSIFICATIONS_LOOKUP_SUCCESS:
      state = { ...state, classificationsLookupList: action.payload, loadingClassificationsLookup: false };
      break;
    case GET_CLASSIFICATIONS_LOOKUP_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingClassificationsLookup: false,
      };
      break;

    case PROPOSE_POSITION_MAPPING:
      state = { ...state, postingResult: {}, loading: true };
      break;
    case PROPOSE_POSITION_MAPPING_SUCCESS:
      state = { ...state, postingResult: action.payload, loading: false };
      break;
    case PROPOSE_POSITION_MAPPING_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        postingResult: {},
        loading: false,
      };
      break;

    case GET_PENDING_POSITION_MAPPINGS:
      state = { ...state, loadingPending: true };
      break;
    case GET_PENDING_POSITION_MAPPINGS_SUCCESS:
      state = { ...state, pendingList: action.payload, loadingPending: false };
      break;
    case GET_PENDING_POSITION_MAPPINGS_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingPending: false,
      };
      break;

    case DECIDE_POSITION_MAPPING:
      state = { ...state, postingResult: {}, loading: true };
      break;
    case DECIDE_POSITION_MAPPING_SUCCESS:
      state = { ...state, postingResult: action.payload, loading: false };
      break;
    case DECIDE_POSITION_MAPPING_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        postingResult: {},
        loading: false,
      };
      break;

    case GET_MY_MAPPING_HISTORY:
      state = { ...state, loadingMyHistory: true };
      break;
    case GET_MY_MAPPING_HISTORY_SUCCESS:
      state = { ...state, myHistoryList: action.payload, loadingMyHistory: false };
      break;
    case GET_MY_MAPPING_HISTORY_FAIL:
      state = {
        ...state,
        error: { message: "Error" },
        loadingMyHistory: false,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default PositionMappingReducer;
